export function getProMatchlistQueryString(
  championId: string | number | null,
  role: string | null,
  proId?: string | number,
) {
  const queryParams = new URLSearchParams();
  if (role) queryParams.set("role", role === "BOT" ? "BOTTOM" : role);
  if (championId) queryParams.set("champion_id", `${championId}`);
  if (proId) queryParams.set("pro_id", `${proId}`);
  return queryParams.toString();
}
